/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListGlobalRemoteSessionIssuersResult,
  ListGlobalRemoteSessionIssuersResult$inboundSchema,
} from "../components/listglobalremotesessionissuersresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListGlobalRemoteSessionIssuersSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListGlobalRemoteSessionIssuersRequest = {
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListGlobalRemoteSessionIssuersResponse = {
  result: ListGlobalRemoteSessionIssuersResult;
};

/** @internal */
export type ListGlobalRemoteSessionIssuersSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGlobalRemoteSessionIssuersSecurity$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionIssuersSecurity$Outbound,
    ListGlobalRemoteSessionIssuersSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionIssuersSecurityToJSON(
  listGlobalRemoteSessionIssuersSecurity:
    ListGlobalRemoteSessionIssuersSecurity,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionIssuersSecurity$outboundSchema.parse(
      listGlobalRemoteSessionIssuersSecurity,
    ),
  );
}

/** @internal */
export type ListGlobalRemoteSessionIssuersRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListGlobalRemoteSessionIssuersRequest$outboundSchema:
  z.ZodMiniType<
    ListGlobalRemoteSessionIssuersRequest$Outbound,
    ListGlobalRemoteSessionIssuersRequest
  > = z.pipe(
    z.object({
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function listGlobalRemoteSessionIssuersRequestToJSON(
  listGlobalRemoteSessionIssuersRequest: ListGlobalRemoteSessionIssuersRequest,
): string {
  return JSON.stringify(
    ListGlobalRemoteSessionIssuersRequest$outboundSchema.parse(
      listGlobalRemoteSessionIssuersRequest,
    ),
  );
}

/** @internal */
export const ListGlobalRemoteSessionIssuersResponse$inboundSchema:
  z.ZodMiniType<ListGlobalRemoteSessionIssuersResponse, unknown> = z.pipe(
    z.object({
      Result: ListGlobalRemoteSessionIssuersResult$inboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        "Result": "result",
      });
    }),
  );

export function listGlobalRemoteSessionIssuersResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListGlobalRemoteSessionIssuersResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListGlobalRemoteSessionIssuersResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListGlobalRemoteSessionIssuersResponse' from JSON`,
  );
}
